import { render, staticRenderFns } from "./ImsNavbar.vue?vue&type=template&id=4761e28a"
import script from "./ImsNavbar.vue?vue&type=script&lang=js"
export * from "./ImsNavbar.vue?vue&type=script&lang=js"
import style0 from "./ImsNavbar.vue?vue&type=style&index=0&id=4761e28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports